import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import * as Template from "../../templates";
import * as actions from "../../actions";
import EditorField from "../../templates/modules/forms/Editor";
import { useNavigate, useParams } from "react-router-dom";

export default () => {

  const moduleName = `bundles`;

  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();
  const [id, setId] = useState();
  const [submitted, setSubmitted] = useState(false);
  const [searchTerm, setSearchTerm] = useState('')
  const [name, setName] = useState(``);
  const [code, setCode] = useState(``);
  const [state, setState] = useState(``);
  const [description, setDescription] = useState(``);
  const [availableCount, setAvailableCount] = useState(``);
  const [image, setImage] = useState(``);
  const [loadingPrice, setLoadingPrice] = useState(false);
  const [loadPrices, setLoadPrices] = useState([])
  const [metaDescription, setMetaDescription] = useState(``);
  const [metaKeywords, setMetaKeywords] = useState(``);
  const [metaTitle, setMetaTtitle] = useState(``);
  const [slug, setSlug] = useState(``);
  const [images, setImages] = useState(``);

  const params = useParams()
  const navigate = useNavigate()

  const handleImage = () => dispatch(actions.upload(id, "bundle_images"));

  const handleDeleteImage = (id) => dispatch(actions.destroy(id, "bundle_images"))

  const handleDefaultImage = (id) => dispatch(actions.edit(id, "bundle_images"))

  const fixProductItem = {
    id: 0,
    code: "",
    available_count: "",
    percent: ""
  }

  const locale = {
    code: "کدتنوع محصول",
    available_count: "تعداد",
    percent: "تخفیف"
  }

  const [products, setProducts] = useState([fixProductItem])

  const handleDelete = (index) => {
    setProducts([
      ...products.slice(0, index),
      ...products.slice(index + 1, products.length)
    ]);
  }

  const handleChangeState = (value) => setState(value);

  const handleAboutChange = (value) => setDescription(value);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchTerm) {

        let query = searchTerm.split("_")

        dispatch(actions.list("product_prices", `?price_code=${query[1]}`));

      }
    }, 2000)

    return () => clearTimeout(delayDebounceFn)
  }, [searchTerm])

  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };

  useEffect(() => {

    if (submitted) {
      if (
        (appReducer.bundles_store != undefined && appReducer.bundles_store.error == false) ||
        (appReducer.bundles_update != undefined && appReducer.bundles_update.error == false)
      ) {
        navigate(-1)
      }
    }

    if (appReducer.bundle_images_upload != undefined || appReducer.bundle_images_destroy != undefined
    ) {
      dispatch(actions.edit(id, moduleName));
    }

    if (appReducer.product_prices_list != undefined) {

      let query = searchTerm.split("_")

      let activePrice = appReducer.product_prices_list.data[0]

      if (activePrice != undefined) {

        let newArray = loadPrices

        newArray[query[0]] = `${activePrice.product.name} ${activePrice.name} -  ${activePrice.price} تومان`

        setLoadingPrice(false)

        setLoadPrices(newArray);

      }

    }

    return () => setSubmitted(false)
  }, [
    appReducer.bundles_store,
    appReducer.bundles_update,
    appReducer.bundle_images_destroy,
    appReducer.bundle_images_upload,
    appReducer.product_prices_list
  ])

  const appendNewItem = () => setProducts([...products, fixProductItem]);

  useEffect(() => {
    if (appReducer.bundles_edit != undefined && id != undefined) {
      let row = appReducer.bundles_edit.data;
      if (row) {
        setName(row.name)
        setDescription(row.description)
        setCode(row.code)
        setImage(row.image_full)
        setSlug(row.slug)
        setImages(row.bundle_images)
        setMetaKeywords(row.meta_keywords)
        setMetaDescription(row.meta_description)
        setMetaTtitle(row.meta_title)
        setAvailableCount(row.available_count)
        setState({
          value: row.state,
          label: row.state == `active` ? `فعال` : `غیرفعال`,
        });
        setProducts(row.bundle_items)
      }
    }
  }, [appReducer.bundles_edit]);

  useEffect(() => {
    dispatch(actions.list(moduleName));
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])

  return <Template.Form>

    {id && (
      <form className="mb-5" id="upload" method="post">

        <div className="flex flex-col space-y-2">
          <Template.FileInput name="image" label="تصویر" />
          <Template.Button
            label="آپلود"
            background="bg-gradient-to-tr from-blue-300 to-blue-400"
            onClick={handleImage}
          />
        </div>

        {images && <div className="my-4 flex flex-col space-y-5 bg-gray-100 p-5">
          {
            images.map((image, im) => {
              return <div className="flex justify-between items-center w-full" key={im} >
                <img src={image.url_medium_full} />
                <div className="flex gap-3 items-center">
                  <Template.Button onClick={() => handleDeleteImage(image.id)} label="حذف" background="bg-gradient-to-tr from-red-300 to-red-400" />
                  <Template.Button onClick={() => handleDefaultImage(image.id)} label="پیش فرض" />
                  {image.default == 1 ? <span>  <svg className=" flex-shrink-0 size-10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M17 9L9.99998 16L6.99994 13M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#8ce175" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
                  </span> : ""}
                </div>
              </div>
            })
          }
        </div>}
      </form>
    )}

    <Template.Input
      required
      value={name}
      label="نام"
      name="name"
      type="text"
    />
    <Template.Input
      required
      value={slug}
      label="نام انگلیسی"
      name="slug"
      type="text"
    />

    <div>
      <EditorField
        label="توضیحات"
        onEditorChange={handleAboutChange}
        value={description}
      />
      <input name="description" type="hidden" defaultValue={description} />
    </div>
    <Template.FileInput
      deleteUrl="bundles/destroy_image"
      rowId={id}
      required
      className="logo"
      value={image && [image]}
      name="image"
      label="تصویر بسته‌های شگفت‌ انگیز"
    />
    <Template.Input
      required
      value={code}
      label="کد"
      name="code"
      type="text"
    />
    <Template.Input
      required
      value={availableCount}
      label="تعداد بسته‌های شگفت‌ انگیز"
      name="available_count"
      type="text"
    />
    <Template.SingleSelect
      withLabel
      required
      placeholder="وضعیت"
      onChange={handleChangeState}
      name="state"
      value={state}
      options={[
        {
          value: "active",
          label: "فعال",
        },
        {
          value: "deactive",
          label: "غیرفعال",
        },
      ]}
    />
    <div className=" flex justify-between items-center">
      <h3 className=" font-bold text-lg">محصولات</h3>
      <Template.Button label="افزودن مورد جدید" onClick={() => appendNewItem()} background="bg-gradient-to-tr from-blue-300 to-blue-400" />
    </div>

    {products.map(function (days, key) {

      return <div key={key} className=" grid grid-cols-4 gap-5">
        {
          Object.entries(days).map((item, m) => {

            if (locale[item[0]] != undefined) {
              return <div >

                <Template.Input
                  required
                  value={item[1]}
                  label={locale[item[0]]}
                  name={`products[${key}][${item[0]}]`}
                  onChange={(e) => {
                    if (item[0] == "code") {
                      setLoadingPrice(true)
                      setSearchTerm(`${key}_${e.target.value}`)
                    }
                  }}
                  type="text"
                />

                {loadPrices[key] != undefined && item[0] == "code" && <span>{loadPrices[key]}</span>}

                {item[0] == "code" && loadingPrice && <img style={{ width: "20px", position: "absolute", left: 25, top: 40 }} src="/images/loading.gif" />}

                {days.product_price && !loadPrices[key] && item[0] == "code" && <span className="py-4 block text-blue-400">{`${days.product_price.product.name} ${days.product_price.name} - ${days.product_price.price} تومان`}</span>}

              </div>
            }
            if (item[0] == "id") {
              return <button className=" bg-rose-100 text-rose-500 rounded-md" onClick={() => handleDelete(key)}>حذف</button>
            }
          })
        }
      </div>
    })}

    <Template.Seo
      keywords={metaKeywords}
      description={metaDescription}
      title={metaTitle}
    />

    <Template.Button
      label="ذخیره"
      onClick={handleClick}
    />
  </Template.Form>
};